<template>
  <div>
    <h1>New quote</h1>
    <ValidationObserver ref="observer">
      <form @submit.prevent="submit()">
        <FormFieldsLead :form-fields="form" :errors="errors" @input="handleFormInput" render-pickup-contact-form
          render-delivery-contact-form render-shipping-form :show-customer-search="true" />
        <button :disabled="submitDisabled" class="btn btn-primary">Save</button>
      </form>
    </ValidationObserver>
    <BottomPanel :form-fields="form" />
  </div>
</template>

<script>
import { ApiClient } from '@/api/ApiClient';
import FormFieldsLead from '@/components/shared/formFields/FormFieldsLead';
import BottomPanel from "@/components/shared/BottomPanel.vue";

export default {
  name: 'QuoteNew',
  components: { FormFieldsLead, BottomPanel },
  data() {
    return {
      errors: {},
      customers: [],
      form: {
        customer: {
          contact: {},
        },
        vehicles: [{}],
        pickupLocation: {},
        pickupContact: {},
        deliveryLocation: {},
        deliveryContact: {},
        sourceId: null,
      },
      submitDisabled: false,
    };
  },
  methods: {
    handleFormInput(newForm) {
      this.form = newForm;
    },
    async submit() {
      const isValid = await this.$refs.observer.validate();
      if (isValid) {
        this.save();
      } else {
        this.handleSendErrorToast({ message: 'Required field(s) missing.' });
      }
    },
    async save() {
      if (this.submitDisabled) return;

      this.submitDisabled = true;
      const body = Object.assign({}, this.form, { lead_type_id: 2, lead_status_id: 2 });
      const response = await ApiClient.leads.post({ body });
      this.submitDisabled = false;
      if (response.status === 200) {
        this.errors = {};
        const newQuote = response.data.data;
        this.$router.push({ name: 'QuoteDetails', params: { id: newQuote.id } });
      } else if (response.status === 422) {
        this.errors = response.data.errors;
      }
    },
    handleSendErrorToast({ message }) {
      this.$bvToast.toast(message, {
        title: 'Error',
        variant: 'danger',
        solid: true,
      });
    },
  },
};
</script>

<style lang="scss" scoped></style>
